module.exports = __webpack_public_path__ + "static/media/white_belt_icon.6be4c196.svg";